import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login';
import Home from '../components/Home';
import Pos from "../components/Pos";
import Setting from "../components/Setting";
import Report from "../components/Report";
import Products from "../components/Products";
import Orders from "../components/Orders";
import Merchants from "../components/Merchants";
import Suppliers from "../components/Suppliers";
import VModal from 'vue-js-modal'
import InputTag from 'vue-input-tag';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueXlsx from 'vue-js-xlsx'
import CreditOrders from "../components/CreditOrders";
import VendorOrders from "../components/VendorOrders";
import Notifier from "../components/Notifier";
import Commerce from "../components/Commerce.vue";

Vue.use(VueXlsx)
Vue.use(VModal, { dialog: true, width:'90%' })

Vue.use(Router)
Vue.component('input-tag', InputTag)
//Vue.component('multiselect', Multiselect)
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/static/css/print.css'
  ]
}

Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet

Vue.use(VueHtmlToPaper);
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/merchants',
      name: 'Merchants',
      component: Merchants
    },
    {
      path: '/vendors',
      name: 'Suppliers',
      component: Suppliers
    },
    {
      path: '/vendorOrders',
      name: 'Vendor Orders',
      component: VendorOrders
    },
    {
      path: '/pos',
      name: 'Pos',
      component: Pos
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/report',
      name: 'Report',
      component: Report
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/credits',
      name: 'Credits',
      component: CreditOrders
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/notifier',
      name: 'Notifier',
      component: Notifier
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '/commerce',
      name: 'Commerce',
      component: Commerce,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js